// Manual-entry adapter for the v0.3 WebUI.
//
// Takes a fully-typed `DemoNewSupplyFile` from the React form (no
// parsing involved), runs the existing core engine, and produces the
// same `RunResult` envelope the file-upload adapter returns. No
// calculation rules are duplicated here — this is a thin shim.

import {
  calculateNewSupplyLandPrice,
  type CalculateNewSupplyInput,
} from "../../logic/index.js";
import type { CalculationResult } from "../../types/calculation-result.js";
import type { ValidationMessage } from "../../types/validation.js";

import type { RunResult } from "./runFile.js";

export interface RunNewSupplyOutput {
  readonly result: RunResult;
  readonly errors: readonly ValidationMessage[];
}

export function runNewSupplyInput(
  input: CalculateNewSupplyInput,
): RunNewSupplyOutput {
  // Run the engine — let any thrown error bubble up to the caller
  // (the form is expected to have already validated the basics).
  const r: CalculationResult = calculateNewSupplyLandPrice(input);

  return {
    result: {
      calculationType: "新供应土地",
      calculationTypeRaw: "new-supply",
      projectName: input.parcel.projectName,
      calculationDate: input.parcel.calculationDate,
      marketPrices: input.prices,
      totalLandPrice: r.totalLandPrice,
      totalChargeableGfa: r.totalChargeableGfa,
      averageFloorLandPrice: r.averageFloorLandPrice,
      itemResults: r.itemResults,
      validationMessages: r.validationMessages,
    },
    errors: [],
  };
}
